import React from 'react';
import { Box, TextField, InputAdornment } from 'minimal-ui';
import { Iconify } from 'minimal-ui';

const SearchBar = ({ searchTerm, onSearchChange }) => {
    return (
        <Box sx={{ px: 2, py: 1, flexShrink: 0 }}>
            <TextField
                fullWidth
                className="form-input-border"
                placeholder="Search by product name or code"
                value={searchTerm}
                onChange={(e) => onSearchChange(e.target.value)}
                sx={{
                    '& .MuiInputBase-root': {
                        backgroundColor: '#F5F5F5',
                        borderRadius: '8px'
                    },
                    '& .MuiInputBase-input': {
                        py: 1.5
                    }
                }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <Iconify icon="eva:search-fill" className="commonColor" />
                        </InputAdornment>
                    ),
                }}
            />
        </Box>
    );
};

export default SearchBar;

